import React from 'react'
import Skeleton from 'react-loading-skeleton'

export default function PreloadPage() {
  return (
    <div className='preload-page'>
        <div className='top'>
            <Skeleton height={80} />
        </div>
        <div className='bottom d-flex justify-content-evenly'>
            <div className='sidebar'><Skeleton height={`100%`} /></div>
            <div className='main'><Skeleton height={`100%`} /></div>
        </div>
    </div>
  )
}


export function LoginPreload() {
  return (
    <div className='auth-preload-page'>
        <div className='content'>
            <Skeleton height={300} />
        </div>
    </div>
  )
}
